import BaseContainer from "@/components/baseContainer";
import { WP_URL } from "@/config";
import { linkToIframe } from "@/utiils";
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '@/config';

const MemberMenu = () => {
  const navigate = useNavigate(); // ← Hook はここで
  const onRegister = () => {
    const target = 'https://skytours.co.jp/anachiiki/';
    const u = encodeURIComponent(target);
    // 自ドメイン配下の中継ページへ
    window.location.href = `/external_link/?u=${u}`;
  };  
  const doLogout = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;
  
      const res = await fetch(`${API_BASE_URL}/v1/user/logout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`, // Basic ではなく Bearer
        },
      });
  
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        console.error('ログアウト失敗', err.error || res.status);
      }
    } catch (err) {
      console.error('ログアウト通信エラー', err);
    } finally {
      localStorage.removeItem('token');
      document.cookie = 'ak_logged_in=; Path=/; Max-Age=0; Secure; SameSite=Lax';
      // navigate('/login');
      linkToIframe('', { isIframeUrl: `${WP_URL}` });
    }
  };
  
  
  const menuItems = [
    [
      {
        label: '会員情報照会',
        // onClick: () => linkToIframe('/user/info', {isIframeUrl: WP_URL + '/info'}),
        onClick: () => linkToIframe('/user/info'),
      },
      {
        label: 'TOPページ',
        onClick: () => linkToIframe('/', {isIframeUrl: '/'}),
      },
      {
        label: 'アンケート回答',
        onClick: () => linkToIframe('/user/survey', {isIframeUrl: WP_URL + '/survey'}),
      },
    ],
    [
      {
        label: 'お問い合わせ', 
        // onClick: () => linkToIframe('/user/contact'),
        onClick: () => linkToIframe('/contact', {isIframeUrl: '/contact'}),
      },
      {
        label: 'お問い合わせ履歴照会',
        onClick: () => linkToIframe('/user/contact_history'),
      },
      {
        label: '退会について',
        onClick: () => linkToIframe('/user/withdraw'),
      },
      {
        label: 'ログアウト',
        onClick: () => {
          
          // localStorage.removeItem('token');
          // document.cookie = 'ak_logged_in=; Path=/; Max-Age=0; Secure; SameSite=Lax'
          // linkToIframe('/user/login', {isIframeUrl: WP_URL + '/login'});
          doLogout();
          
        }
      },
    ],
  ];

  return (
    <div>
      <BaseContainer fullWidth={true}>
        <p className="m-icon-title" style={{ 'color': 'var(--color-sun)' }}><em className="m-icon-bars"></em><span>会員メニュー</span></p>
        <div className="xmd:flex gap-x-[10rem]">
          <button className="m-btn fill text-[1.4rem]" onClick={onRegister}>
            <span>お試し二地域プランお申し込み</span>
            <em className="m-icon-blank suffix"></em>
          </button>
          <div className="flex-1 xmd:flex gap-x-[10rem] mt-[2.8rem] xmd:mt-0">
            {menuItems.map((items, i) => (
            <ul key={i}>
              {items.map((item, j) => (
                <li key={`${i}-${j}`} className="mb-4">
                  <button onClick={item.onClick} className="flex items-center gap-x-2 text-[var(--color-sea)] font-medium hover:underline">
                    <span>{item.label}</span>
                    <em className="m-arrow" style={{ 'fontSize': '80%' }}></em>
                  </button>
                </li>
              ))}
            </ul>
            ))}
          </div>
        </div>
      </BaseContainer>
    </div>
  );
};

export default MemberMenu;